export const SHARE_CAMPAIGN_VERSION = "share_v1";
export const SHARE_LANDING_CAMPAIGN_VERSION = "share_v1_landing";
export const SHARE_PORTAL_URL = "https://www.ourlinkedlives.com/share";
export const SHARE_LINK_MEDIUMS = Object.freeze({
  e: "email",
  t: "sms",
  l: "link",
  n: "native",
  f: "qr_flyer",
  c: "qr_cards",
});
const shortLinkCodes = Object.freeze({ email: "e", sms: "t", link: "l", native: "n" });
export const buildShareJoinUrl = (medium, entrySource = "") => {
  const qrFormat = medium === "qr_flyer" ? "flyer" : medium === "qr_cards" ? "cards" : null;
  const campaign = qrFormat
    ? `${SHARE_CAMPAIGN_VERSION}_${qrFormat}${entrySource === "landing_page" ? "_landing" : ""}`
    : entrySource === "landing_page"
      ? SHARE_LANDING_CAMPAIGN_VERSION
      : SHARE_CAMPAIGN_VERSION;
  return `https://www.ourlinkedlives.com/join?utm_source=member_share&utm_medium=${qrFormat ? "qr" : medium}&utm_campaign=${campaign}`;
};
export const buildShareDestinationUrl = (medium = "link", entrySource = "") =>
  shortLinkCodes[medium]
    ? `https://www.ourlinkedlives.com/s/${shortLinkCodes[medium]}${entrySource === "landing_page" ? "?src=landing_page" : ""}`
    : buildShareJoinUrl(medium, entrySource);
export const SHARE_FALLBACK_PHONE = "(833) 433-0363";

// The same label is used on every invitation surface. Change or add a variant here.
const SHARE_INVITATION = "Know someone who could use a hand around the house? Introduce them to Linked Lives and help brighten their day while supporting local students.";
export const SHARE_COPY = Object.freeze({
  tell: Object.freeze({ label: "Tell a friend", invitation: SHARE_INVITATION }),
  share: Object.freeze({ label: "Share with a friend", invitation: SHARE_INVITATION }),
  refer: Object.freeze({ label: "Refer a friend", invitation: SHARE_INVITATION }),
  print: Object.freeze({ label: "Print and share", invitation: SHARE_INVITATION }),
});

export const getShareCopy = (variantKey = "tell") => SHARE_COPY[variantKey] || SHARE_COPY.tell;
export const SHARE_SIDEBAR_LABELS = Object.freeze({ share: "Share", refer: "Refer", print: "Print" });
export const SHARE_METHODS_SUBTITLE = "Print flyers or share online";
export const SHARE_EMAIL_LINE_REVISION = "share_email_line_v1_r1";
export const SHARE_ENTRY_SUBTITLES = Object.freeze({
  friend: "Could a friend use a hand at home? Pass this along.",
  local: "Help a friend book a local student helper.",
});
export const buildShareQrUrl = (format, entrySource = "") =>
  `https://www.ourlinkedlives.com/s/${format === "cards" ? "c" : "f"}${entrySource === "landing_page" ? "?src=landing_page" : ""}`;
export const buildShareMessage = (medium = "link", entrySource = "") =>
  `Thought you might like Linked Lives. Local student helpers can lend a hand at home: ${buildShareDestinationUrl(medium, entrySource)}`;
